import React from "react";
import help from "../../assets/help.png";
import homepage from "../../assets/about/homepage.jpg";
import "./DonateFood.css";
import { useNavigate } from "react-router-dom";

const DonateToFood = ({image,style}) => {
  const navigate = useNavigate();
  return (
    // <div className="donate">
    //   <div className="donate-message">
    //     <h2>
    //       Donate to help India’s <br /> children & their <br /> food
    //     </h2>
    //     <div>
    //       <button className="donate-btn" onClick={() => navigate('/donate-form')}>DONATE NOW</button>
    //     </div>
    //   </div>
    //   {/* <img src={help} alt="donate now" /> */}
    //   <img src={image || help} alt="donate now" style={style} />
    // </div>
    <div className="help-section">
    <div className="donate-container">
      <div className="text-content">
        <h2>Donate to help India's children & their studies</h2>
        <button className="donate-btn" onClick={() => navigate('/donate-form')}>DONATE NOW</button>
      </div>
      <div className="image-content">
        <img
          src={homepage || help}
          // style={{width: "167%"}}
          alt=""
          className="help-image"
        />
      </div>
    </div>
   </div>
  );
};

export default DonateToFood;
